export const VerificationResultStatus = {
  Verified: 0,
  AlreadyVerified: 1,
  InvalidOrExpired: 2,
};
